/* eslint-disable max-len */
import 'react';

const LoadPromptSvg = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
        <circle cx="7" cy="7" r="5.705" stroke="#1C1D1F" strokeWidth="0.839999" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7 10.0625V6.5625" stroke="#1C1D1F" strokeWidth="1.26" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M6.99978 4.375H7.00853" stroke="#1C1D1F" strokeWidth="1.68" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);
export default LoadPromptSvg;
